import React from "react";
import { Link } from "react-router-dom";
import { Box, Drawer, List, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { QrCodeScanner as QrCodeScannerIcon } from "../icons";
import { QrCode2 as QrCode2Icon } from "../icons";
import { ChevronRight as ChevronRightIcon } from "../icons";
import { T } from "../routes/Translate";
import SheetDragHandle from "./SheetDragHandle";
import { brandColors } from "../theme";
import { PAGE_CONTENT_MAX_WIDTH } from "../pageLayout";

const OPTIONS = [
  {
    to: "/QRScanner",
    Icon: QrCodeScannerIcon,
    title: "Escanear QR",
    subtitle: "Cobrá un cupón o pagá leyendo un código QR",
  },
  {
    to: "/PaymentQRGenerator",
    Icon: QrCode2Icon,
    title: "Generar QR de cobro",
    subtitle: "Creá un código para que te paguen",
  },
];

// Panel del botón central de la BottomToolbar (mobile y app) para quienes
// tienen suscripción activa: elegir entre escanear un QR o generar uno de
// cobro, en vez de abrir la cámara directo.
const QrActionsSheet = ({ open, onClose }) => (
  <Drawer
    anchor="bottom"
    open={open}
    onClose={onClose}
    PaperProps={{ sx: { borderTopLeftRadius: 16, borderTopRightRadius: 16 } }}
  >
    <Box sx={{ pt: 1.5, pb: 4, px: 2, width: "100%", maxWidth: `${PAGE_CONTENT_MAX_WIDTH}px`, mx: "auto", boxSizing: "border-box" }}>
      <SheetDragHandle onClose={onClose} />
      <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
        <T>Pagos con QR</T>
      </Typography>
      <List disablePadding>
        {OPTIONS.map(({ to, Icon, title, subtitle }) => (
          <ListItemButton
            key={to}
            component={Link}
            to={to}
            onClick={onClose}
            sx={{ borderRadius: 2, py: 1.5, mb: 1, border: `1px solid ${brandColors.divider}` }}
          >
            <ListItemIcon sx={{ minWidth: 48 }}>
              <Icon sx={{ fontSize: 30, color: brandColors.accent }} />
            </ListItemIcon>
            <ListItemText
              primary={<T>{title}</T>}
              secondary={<T>{subtitle}</T>}
              primaryTypographyProps={{ fontWeight: 600 }}
            />
            <ChevronRightIcon sx={{ color: brandColors.textSecondary }} />
          </ListItemButton>
        ))}
      </List>
    </Box>
  </Drawer>
);

export default QrActionsSheet;
